import MobileNav from '../plugins/mobileNavPlugin';
import AccessibilityNav from '../plugins/accessibilityNavPlugin';

const menuHolder = document.querySelector('body');
const header = document.getElementById('header');

const mobileNav = new MobileNav(menuHolder, {
  onShow() {
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('keydown', handleKeyPress);
    header.classList.add('header-nav-active');
  },
  onHide() {
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    mobileNav.btnOpeners[0].focus();
    document.removeEventListener('keydown', handleKeyPress);
    header.classList.remove('header-nav-active');
  },
});

function initMobileNav() {
  mobileNav.init();
}

function initAccessibilityNav() {
	document.querySelectorAll('.menubar').forEach(nav => {
		new AccessibilityNav(nav, '1024px');
	});
}

function handleKeyPress(event) {
  const keys = getKeyboardFocusableElements(mobileNav.outSideContainer);
  const firstItem = keys.slice(0)[0];
  const lastItem = keys.slice(-1)[0];
  let currentItem = document.activeElement;

  if (event.shiftKey && event.keyCode == 9) {
    if (currentItem == firstItem) {
      setTimeout(() => {
        lastItem.focus()
      }, 50)
      event.preventDefault();
    }
  } else if (event.key == "Tab") {
    if (currentItem == lastItem) {
      setTimeout(() => {
        firstItem.focus()
      }, 50)
      event.preventDefault();
    }
  } else if (event.key == "Escape") {
    mobileNav.hide();
  }
}

function getKeyboardFocusableElements(element = document) {
  return [
    ...element.querySelectorAll(
      'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
    ),
  ].filter(
    el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'),
  )
}

export {initMobileNav, initAccessibilityNav}
